/// <amd-module name="TFS/Identities/ProjectScopedIdentitySearchService/ProjectScopedIdentitySearchService" />

import { ITfsPageService } from "Tfs/Platform/Page";
import { IIdentity, IVssIdentitySearchService, IVssIdentityService, VssIdentityServiceName } from "VSS/Features/Identities/IdentityService";
import {
    IVssPageContext,
    Services,
    VssService
} from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

/**
 * Name of the ProjectScopedIdentitySearchServiceName
 */
export const ProjectScopedIdentitySearchServiceName = "ms.vss-tfs-identities.project-scoped-identity-search-service";

class ProjectScopedIdentitySearchService extends VssService implements IVssIdentitySearchService {
    private baseService: IVssIdentityService | undefined;
    private scopeId: string | undefined
    private telemetryService: IVssTelemetryService | undefined;

    private static readonly area = "IdentityPicker";
    private static readonly feature = "ProjectScoped";

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);
        this.baseService = pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
        const pageService = pageContext.getService<ITfsPageService>("ITfsPageService");
        this.scopeId = pageService.getData()?.project?.id;
        this.telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    }

    public async searchIdentitiesAsync(query: string, identityTypes?: string[], operationScopes?: string[], queryTypeHint?: string, options?: any, filterIdentity?: (returnedEntities: IIdentity[]) => IIdentity[]): Promise<IIdentity[]> {
        try {
            // if scopeId is defined inject the request with scopeId and search "ims" only
            const result = await this.baseService!.searchIdentitiesAsync(
                query,
                identityTypes,
                this.scopeId ? ["ims"] : operationScopes,
                queryTypeHint,
                this.scopeId
                    ? {
                        ScopeId: this.scopeId,
                        ...options
                    }
                    : options,
                filterIdentity);

            this.telemetryService?.publishEvent(ProjectScopedIdentitySearchService.area, ProjectScopedIdentitySearchService.feature, {
                projectScoped: !!this.scopeId
            });
            return result;
        } catch (e) {
            this.telemetryService?.publishEvent(ProjectScopedIdentitySearchService.area, ProjectScopedIdentitySearchService.feature, {
                projectScoped: !!this.scopeId,
                errorMessage: e.message,
            });
            throw e;
        }
    }

    /**
     * Get scope ID for legacy web platform
     */
    public getScopeId(): string | undefined {
        this.telemetryService?.publishEvent(ProjectScopedIdentitySearchService.area, ProjectScopedIdentitySearchService.feature, {
            projectScoped: !!this.scopeId,
            lwp: true, // legacy web platform
        });
        return this.scopeId;
    }

}

Services.add("ms.vss-tfs-identities.project-scoped-identity-search-service", { serviceFactory: ProjectScopedIdentitySearchService });